import React from 'react';
import moment from 'moment';
import {API_IMAGE_URL} from '../../lib/api'
export default function AttendanceTable({ employee, attendances }) {
  return (
    <div className="container mx-auto mt-4 px-4">
      <div className="mb-3">
        <button
          onClick={() => window.history.back()}
          className="px-3 py-1 border border-gray-400 rounded hover:bg-gray-100 transition"
        >
          ← Back
        </button>
      </div>

      <div className="shadow border-2 border-blue-600 rounded mb-4">
        <div className="bg-blue-600 text-white p-4 rounded-t">
          <h4 className="m-0 font-semibold">Employee Attendance Report</h4>
        </div>
        <div className="flex flex-col md:flex-row text-center md:text-left gap-2 p-4 text-sm md:text-base">
          <div className="flex-1"><strong>Employee ID:</strong> {employee.employee_id}</div>
          <div className="flex-1"><strong>Name:</strong> {employee.full_name}</div>
          <div className="flex-1"><strong>Contact:</strong> {employee.phone}</div>
        </div>
      </div>

      {Object.entries(attendances).map(([month, records]) => {
        const monthName = moment(`${month}-01`).format('MMMM YYYY');
        const totalDays = records.length;
        const totalDecimalHours = records.reduce((acc, r) => {
          if (!r.working_hours) return acc;
          const parts = r.working_hours.split('h');
          const h = parseInt(parts[0]) || 0;
          const m = parseInt((parts[1] || '').replace('m', '').trim()) || 0;
          return acc + h + m / 60;
        }, 0);
        const fullWorkingDays = (totalDecimalHours / 8).toFixed(2);

        // Helper for working_hours cell classes
        const getHoursClasses = (working_hours) => {
          if (!working_hours) return 'bg-red-600 text-white';
          const match = working_hours.match(/(\d+)h\s*(\d+)m/);
          const hours = match ? parseInt(match[1]) : 0;
          const minutes = match ? parseInt(match[2]) : 0;
          const totalHrs = hours + minutes / 60;
          if (totalHrs < 4) return 'bg-red-600 text-white';
          if (totalHrs < 7) return 'bg-yellow-300 text-yellow-900';
          return 'bg-green-600 text-white';
        };

        return (
          <div key={month} className="shadow rounded mb-6 border">
            <div className="bg-cyan-600 text-white px-4 py-2 flex flex-col md:flex-row justify-between items-center rounded-t">
              <h5 className="text-lg font-semibold">{monthName}</h5>
              <small className="mt-1 md:mt-0 text-sm">
                <strong>Total Days:</strong> {totalDays} |{' '}
                <strong>Total Hours:</strong> {totalDecimalHours.toFixed(2)}h |{' '}
                <strong>Full Days:</strong> {fullWorkingDays}
              </small>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full text-center border-collapse border border-gray-300">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="border border-gray-300 px-2 py-1">#</th>
                    <th className="border border-gray-300 px-2 py-1">Date</th>
                    <th className="border border-gray-300 px-2 py-1">Entry</th>
                    <th className="border border-gray-300 px-2 py-1">Exit</th>
                    <th className="border border-gray-300 px-2 py-1">Working Hours</th>
                    <th className="border border-gray-300 px-2 py-1">Remark</th>
                    <th className="border border-gray-300 px-2 py-1">Approved</th>
                  </tr>
                </thead>
                <tbody>
                  {records.map((rec, index) => (
                    <tr key={rec.id} className="hover:bg-gray-100">
                      <td className="border border-gray-300 px-2 py-1">{index + 1}</td>
                      <td className="border border-gray-300 px-2 py-1">
                        {moment(rec.date).format('DD MMM YYYY')}
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        {rec.entry_photo && (
                          <img
                            src={`${API_IMAGE_URL}${rec.entry_photo}`}
                            alt="entry"
                            className="w-12 h-16 rounded border border-gray-300 mb-1 object-cover mx-auto"
                          />
                        )}
                        <div className="text-xs">{rec.entry_time}</div>
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        {rec.exit_photo && (
                          <img
                            src={`${API_IMAGE_URL}${rec.exit_photo}`}
                            alt="exit"
                            className="w-12 h-16 rounded border border-gray-300 mb-1 object-cover mx-auto"
                          />
                        )}
                        <div className="text-xs">{rec.exit_time}</div>
                      </td>
                      <td className={`border border-gray-300 px-2 py-1 font-semibold ${getHoursClasses(rec.working_hours)}`}>
                        {rec.working_hours || '0'}
                      </td>
                      <td className="border border-gray-300 px-2 py-1">{rec.remark || '-'}</td>
                      <td className="border border-gray-300 px-2 py-1 text-lg">
                        {rec.is_approved ? '✔️' : '❌'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
}
